import { PageTitle, PositiveFeedback, NegativeFeedback, useNotifications } from '@goparrot-dashboard/shared-ui';
import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useActivateUser } from '@goparrot-dashboard-api/auth';
import { useI18n } from '@goparrot-dashboard/i18n';
import { SignInSubtitle } from '../components/SignInSubtitle';
import { SignInLink } from '../components/SignInLink';
import { EMAIL_AUTOCOMPLETE_KEY } from '../constants';

/**
 * @description Page to be opened from link sent right after self-registration
 */
export const ConfirmAccountPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();
  const { notifyError } = useNotifications();

  const { params } = useRouteMatch<{ token: string }>();
  const activateUser = useActivateUser({
    onError: () => {
      notifyError({
        text: getIntlString('error.confirmAccount'),
      });
    },
    onSuccess: (response) => {
      sessionStorage.setItem(EMAIL_AUTOCOMPLETE_KEY, response.email);
    },
  });

  React.useEffect(() => {
    if (params?.token) {
      activateUser.mutate({
        emailValidationToken: params.token,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.token]);

  return (
    <>
      <header>
        <PageTitle hasMargin={false} fontWeight="medium" seoTitle={getIntlString('title.activateAccount')}>
          {getIntlString('title.activateAccount')}
        </PageTitle>
        <SignInSubtitle />
      </header>
      <section className="tw-my-4">
        {activateUser.data ? (
          <PositiveFeedback
            title={getIntlString('feedback.activateSuccess.title')}
            subtitle={
              <div>
                <p className="tw-mb-1">{getIntlString('feedback.activateSuccess.subtitle.first')}</p>
                <p>
                  <SignInLink /> {getIntlString('feedback.activateSuccess.subtitle.second')}
                </p>
              </div>
            }
          />
        ) : activateUser?.error ? (
          <NegativeFeedback title={getIntlString('feedback.activateError.title')} subtitle={getIntlString('feedback.activateError.subtitle')} />
        ) : (
          <div className="tw-mt-4 tw-relative">{getIntlString('label.activatingAccount')}</div>
        )}
      </section>
    </>
  );
};
